import React from 'react';
import PropTypes from 'prop-types';

class Logout extends React.Component {
  componentDidMount() {
    this.props.submitLogout();
  }

  render() {
    return (
      <main>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1 className="heading-underline-large">See ya!</h1>
            </div>
          </div>
        </div>
        <section className="section-half-margin">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p>You&#39;ve been logged out successfully.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <a
                  className="btn btn-default"
                  type="button"
                  href="https://www.skinny.co.nz/broadband/"
                >
                  Back to Home
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

Logout.propTypes = {
  submitLogout: PropTypes.func
};

export default Logout;



/** WEBPACK FOOTER **
 ** ./src/components/Logout/Logout.js
 **/